import $ from 'jquery';
import 'slick-carousel';

function initMixedMediaSlider() {
	let slideSpeeds = [7200, 3600];
	let slides = $('.ucg-mixed-media-slider-block .slides');
	let active = $('.ucg-mixed-media-slider-block .slides .slick-active');
	let firstSlide = $('.ucg-mixed-media-slider-block .slides .slide-1');

	slides.on('init', function () {
		firstSlide.find('.frame .tag').delay(1000).addClass('animate');
	});

	slides.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
		$(
			'.ucg-mixed-media-slider-block .slides .slick-slide[data-slick-index="' +
				nextSlide +
				'"] .frame .tag'
		)
			.delay(1000)
			.addClass('animate');
	});

	slides.on('afterChange', function (event, slick, currentSlide, nextSlide) {
		slides.slick('slickSetOption', 'autoplaySpeed', slideSpeeds[1], true);
	});

	if (slides.length && slides.find('.slide-2').length) {
		slides.not('.slick-initialized').slick({
			arrows: false,
			autoplay: true,
			autoplaySpeed: slideSpeeds[0],
			dots: false,
			infinite: true,
			pauseOnHover: false,
			pauseonFocus: false,
			speed: 1000,
		});
	}
}

$(window).on('load resize', function () {
	initMixedMediaSlider();
});
